import type { SearchResult } from "@/lib/types";
import { EntryCard } from "./EntryCard";

interface SearchResultListProps {
  results: SearchResult[];
  query: string;
  onCharacterClick?: (character: string) => void;
}

const MAX_RESULTS = 100;

export function SearchResultList({ results, query, onCharacterClick }: SearchResultListProps) {
  if (results.length === 0) {
    return (
      <div className="text-center text-muted-foreground py-8">
        No results found for "{query}"
      </div>
    );
  }

  const displayResults = results.slice(0, MAX_RESULTS);
  const hasMore = results.length > MAX_RESULTS;

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="text-sm text-muted-foreground mb-4">
        {results.length} result{results.length !== 1 ? "s" : ""} found
        {hasMore && ` (showing first ${MAX_RESULTS})`}
      </div>
      <div className="space-y-3">
        {displayResults.map((result, i) => (
          <EntryCard
            key={`${result.entry.traditional}-${result.entry.jyutping}-${i}`}
            entry={result.entry}
            matchType={result.matchType}
            onCharacterClick={onCharacterClick}
          />
        ))}
      </div>
      {hasMore && (
        <div className="text-center text-muted-foreground py-4 text-sm">
          Refine your search to see more results
        </div>
      )}
    </div>
  );
}
